import React from 'react';

const PrintEducation = ({ data, language }) => {
  return (
    <div className="hidden print:block mb-10">
      <h3 className="text-3xl font-bold text-stone-900 mb-6 flex items-center">
        <span className="w-2 h-8 bg-amber-600 mr-3 rounded"></span>
        {language === 'en' ? 'Education' : 'การศึกษา'}
      </h3>
      <div className="space-y-6">
        {data.map((edu, index) => (
          <div key={index} className="break-inside-avoid bg-gradient-to-br from-amber-50 to-stone-50 p-6 rounded-lg border-l-4 border-amber-600 shadow-sm">
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <h4 className="text-xl font-bold text-stone-900 mb-1">{edu.degree}</h4>
                <h5 className="text-lg text-amber-700 font-semibold mb-2">{edu.specialization}</h5>
                <h6 className="text-base text-stone-600 font-medium">{edu.school}</h6>
              </div>
              <div className="text-right ml-6 flex-shrink-0">
                <div className="bg-white px-4 py-2 rounded-lg border border-amber-200 mb-2">
                  <div className="text-sm text-stone-700">{edu.period}</div>
                </div>
                <div className="text-sm text-stone-600 mb-2">{edu.location}</div>
                <div className="bg-amber-600 text-white px-3 py-1 rounded-lg text-sm font-bold">
                  GPA: {edu.gpa}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrintEducation;